interface S3DocumentList {
	fileName: string
	s3Path: string
}
export interface ICreateDoctorNoteRequestParams {
	userId: string
	noteType: NoteType
	note: string
	parentNoteId: number | string
	addedByAgentType: string
	addedByAgentId: number | string
	s3DocumentList: S3DocumentList[]
	addedBy: string
	referenceId?: string
}

export enum NoteType {
	COACH_DOCTOR_CONNECT = "COACH_DOCTOR_CONNECT",
	COACH_PSYCHOLOGIST_CONNECT = "COACH_PSYCHOLOGIST_CONNECT",
	AI_GENERATED = "AI_GENERATED"
}
